import { APICore } from './apiCore'

const api = new APICore()

function getEventos (params) {
  const baseUrl = '/eventos'
  return api.get(baseUrl, params)
}

function getEvento (id) {
  const baseUrl = `/eventos/${id}`
  return api.get(baseUrl, {})
}

function addEvento (params) {
  const baseUrl = '/eventos'
  return api.createWithFile(baseUrl, params)
}

function updateEvento (params) {
  const baseUrl = '/eventos'
  return api.updateWithFile(baseUrl, params)
}

function deleteEvento (params) {
  const baseUrl = '/eventos'
  return api.delete(baseUrl, params)
}

export { getEventos, getEvento, addEvento, updateEvento, deleteEvento }
